/**
 * Convert a URL slug to a human-readable title-case string.
 *
 * "1-pistol-2-magazine-doro-sport-400-case" → "1 Pistol 2 Magazine Doro Sport 400 Case"
 *
 * Used by:
 *  - config/seo.ts — slug-derived meta title at initial render (before data fetch)
 *  - pages/PremadeCaseDetailPage.tsx — re-exported for test imports
 */
export function slugToTitle(slug: string): string {
  return slug
    .split('-')
    // #417: drop empty segments from consecutive/leading/trailing hyphens so
    // no double/leading/trailing spaces leak into the crawler-visible
    // <title>/<meta description> these strings feed (config/seo.ts).
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
